import { baseApi } from './baseApi';

export const organizationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizations: builder.query({
      query: () => '/admin/organizations',
      providesTags: (result) =>
        result
          ? [
              ...result.map((o) => ({ type: 'Organization', id: o.id })),
              { type: 'Organization', id: 'LIST' },
            ]
          : [{ type: 'Organization', id: 'LIST' }],
    }),
    getOrganization: builder.query({
      query: (organizationId) => `/admin/organizations/${organizationId}`,
      providesTags: (result, error, id) => [{ type: 'Organization', id }],
    }),
    createOrganization: builder.mutation({
      query: (body) => ({ url: '/admin/organizations', method: 'POST', body }),
      invalidatesTags: [{ type: 'Organization', id: 'LIST' }],
    }),
    updateOrganization: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/admin/organizations/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Organization', id },
      ],
    }),
    deleteOrganization: builder.mutation({
      query: (organizationId) => ({
        url: `/admin/organizations/${organizationId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Organization', id: 'LIST' }],
    }),

    getEmailDomains: builder.query({
      query: (organizationId) =>
        `/admin/organizations/${organizationId}/email-domains`,
      providesTags: (result, error, organizationId) => [
        { type: 'EmailDomain', id: `ORG-${organizationId}` },
      ],
    }),
    addEmailDomain: builder.mutation({
      query: ({ organizationId, domain }) => ({
        url: `/admin/organizations/${organizationId}/email-domains`,
        method: 'POST',
        body: { domain },
      }),
      invalidatesTags: (result, error, { organizationId }) => [
        { type: 'EmailDomain', id: `ORG-${organizationId}` },
      ],
    }),
    updateEmailDomain: builder.mutation({
      query: ({ id, domain }) => ({
        url: `/admin/email-domains/${id}`,
        method: 'PATCH',
        body: { domain },
      }),
      invalidatesTags: (result, error, { organizationId }) => [
        { type: 'EmailDomain', id: `ORG-${organizationId}` },
      ],
    }),
    removeEmailDomain: builder.mutation({
      query: ({ id }) => ({
        url: `/admin/email-domains/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { organizationId }) => [
        { type: 'EmailDomain', id: `ORG-${organizationId}` },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetOrganizationsQuery,
  useGetOrganizationQuery,
  useCreateOrganizationMutation,
  useUpdateOrganizationMutation,
  useDeleteOrganizationMutation,
  useGetEmailDomainsQuery,
  useAddEmailDomainMutation,
  useUpdateEmailDomainMutation,
  useRemoveEmailDomainMutation,
} = organizationApi;
